module.exports = __webpack_public_path__ + "static/media/calendar-check.851bfd56.svg";